import { defineStore } from 'pinia'

export class Message {
  timestamp: number = Date.now()
  message: string
  timeout = 5000
  color = 'white'
  count = 0
  link?: string
  showRefresh = false
  isShown: boolean = true
  errorId?: string

  constructor(
    message: string,
    count: number,
    color?: string,
    timeout?: number,
    link?: string,
    showRefresh?: boolean,
    errorId?: string
  ) {
    this.message = message
    this.count = count
    if (timeout) {
      this.timeout = timeout
    }
    if (color) {
      this.color = color
    }
    this.link = link
    if (showRefresh) {
      this.showRefresh = showRefresh
    }
    this.errorId = errorId
  }
}

const useMessaging = defineStore('messaging', {
  state: () => ({
    snackbarMessages: [] as Message[]
  }),
  actions: {
    addError(message: string, link?: string, showRefresh?: boolean, errorId?: string) {
      this.newMessage(message, 'red', 30000, link, showRefresh, errorId)
    },
    addSuccess(message: string, link?: string) {
      this.newMessage(message, 'green', 10000, link)
    },
    addInfo(message: string, link?: string) {
      this.newMessage(message, 'white', 10000, link)
    },
    addWarning(message: string, link?: string) {
      this.newMessage(message, 'orange-darken-2', 10000, link)
    },
    newMessage(
      message: string,
      color: string,
      timeout: number,
      link?: string,
      showRefresh?: boolean,
      errorId?: string
    ) {
      let found = false

      for (const [key, item] of this.snackbarMessages.entries()) {
        if (item.message === message && item.errorId === errorId) {
          this.snackbarMessages.splice(
            key,
            1,
            new Message(message, item.count + 1, color, timeout, link, showRefresh, errorId)
          )
          found = true
          break
        }
      }

      if (!found) {
        this.snackbarMessages.push(
          new Message(message, 1, color, timeout, link, showRefresh, errorId)
        )
      }
    }
  }
})

export default useMessaging
